export default {
      id: "lock-usage",
      viewBox: "0 0 8 10",
      url: __webpack_public_path__ + "sprite-46b249.svg#lock-usage",
      toString: function () {
        return this.url;
      }
    }